var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendly-inline-widget",attrs:{"data-url":"https://calendly.com/gewodo/20mindemo"}})}
var staticRenderFns = []

export { render, staticRenderFns }